var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-bootstrap-typeahead',{attrs:{"data":_vm.suggestions,"minMatchingChars":1},model:{value:(_vm.actionNameFragment),callback:function ($$v) {_vm.actionNameFragment=$$v},expression:"actionNameFragment"}})}
var staticRenderFns = []

export { render, staticRenderFns }